import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SuccessPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-20 px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <span className="text-6xl">🎉</span>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
              Success! 🎉
            </h1>
          </div>
          
          <p className="text-lg text-gray-600 mb-8">
            I'm very happy to see your interest in Practice Dashboard - your new Automated Admin Agent!
          </p>
          
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 underline">
              What Happens Next?
            </h2>
            
            <div className="text-left bg-gray-50 rounded-lg p-6">
              <p className="text-gray-700 mb-4">
                I will be in touch shortly to schedule a personalized demo and a discussion about how we can 
                tailor Practice Dashboard to meet your unique needs. I can't wait to connect with you and take 
                the first steps toward a solution that will become your favorite everyday tool :) Until then, feel 
                free to{' '}
                <a href="/contact" className="text-orange-500 hover:text-orange-600 underline">
                  reach out
                </a>{' '}
                if there's anything specific you'd like me to prepare for the call.
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-gray-600 mb-2">Excited to chat,</p>
            <p className="font-semibold text-gray-900">Pavlo Martinovych</p>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SuccessPage;